export default function PageHero({ eyebrow, title, subtitle, image, testId = "page-hero" }) {
  return (
    <section data-testid={testId} className="relative h-[42vh] min-h-[320px] w-full overflow-hidden bg-jpa-ink">
      {image && (
        <img
          src={image}
          alt=""
          className="absolute inset-0 w-full h-full object-cover opacity-70"
        />
      )}
      <div className="absolute inset-0 bg-gradient-to-r from-jpa-ink/95 via-jpa-ink/70 to-transparent" />
      <div className="relative max-w-[1400px] mx-auto h-full px-4 md:px-8 flex flex-col justify-end pb-10">
        {eyebrow && (
          <span className="inline-block bg-jpa-accent text-jpa-ink px-3 py-1 text-xs font-bold uppercase tracking-widest skew-badge w-fit mb-4">
            {eyebrow}
          </span>
        )}
        <h1 className="font-display text-white text-6xl md:text-7xl lg:text-8xl tracking-wider text-shadow-hero">{title}</h1>
        {subtitle && <p className="mt-3 text-white/85 max-w-2xl text-base md:text-lg">{subtitle}</p>}
      </div>
    </section>
  );
}
